import React, { Fragment } from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { withMenu } from '../../containers/Menus';
import withMenuModals from '../../containers/Modals/menu';
import { customModalStyles } from '../../helpers/constants';
import DeleteIcon from '../../images/icon-trash.svg';
import CloseIcon from '../../images/icon-close.svg';
import * as styles from './style';
import { getParentSelector } from '../../helpers/modal';

class DeleteMenuModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isDeleted: false,
    };
  }

  deleteMenu = () => {
    this.props.deleteMenu(this.props.modal.menuDelete.id);
  };

  componentDidUpdate() {
    const { menuDeleteError, isDeleteMenuFinished, finishDeleteMenu, getMenus } = this.props;
    if (isDeleteMenuFinished && !menuDeleteError) {
      finishDeleteMenu();
      this.setState({ isDeleted: true });
      getMenus();
    }
  }

  closeModal = () => {
    this.props.closeModal();
    this.props.clearMenuErrors();
    setTimeout(() => {
      this.setState({ isDeleted: false, error: false });
    }, 1000);
  };

  render() {
    const { modal, menuDeleteError } = this.props;
    return (
      <Modal
        ariaHideApp={false}
        isOpen={modal.showDeleteMenuModal}
        style={{
          ...customModalStyles,
          content: {
            ...customModalStyles.content,
            width: '90%',
            maxWidth: '450px',
            height: 'auto',
          },
        }}
        onRequestClose={this.state.isDeleted ? this.closeModal : null}
        parentSelector={getParentSelector}
      >
        <styles.Container>
          {this.state.isDeleted && (
            <styles.CloseButton onClick={this.closeModal}>
              <styles.CloseIcon src={CloseIcon} />
            </styles.CloseButton>
          )}
          <styles.Content>
            <styles.Icon src={DeleteIcon} />
            {!menuDeleteError ? (
              <Fragment>
                <styles.Title>
                  {this.state.isDeleted ? 'Cardápio Excluído' : 'Excluir Cardápio'}
                </styles.Title>
                <styles.Text>
                  {this.state.isDeleted
                    ? 'O cardápio foi excluído com sucesso!'
                    : 'Você tem certeza que deseja excluir permanentemente este cardápio?'}
                </styles.Text>
              </Fragment>
            ) : (
              <styles.ErrorContainer>
                <styles.Title>Erro</styles.Title>
                <styles.Text>
                  Ocorreu um erro ao excluir o cardápio. Por favor tente novamente mais tarde.
                </styles.Text>
              </styles.ErrorContainer>
            )}
          </styles.Content>
          <styles.Footer center={this.state.isDeleted || menuDeleteError}>
            {this.state.isDeleted || menuDeleteError ? (
              <styles.CancelButton onClick={this.closeModal}>Fechar</styles.CancelButton>
            ) : (
              <Fragment>
                <styles.CancelButton onClick={this.closeModal}>Cancelar</styles.CancelButton>
                <styles.DeleteButton onClick={this.deleteMenu}>Confirmar</styles.DeleteButton>
              </Fragment>
            )}
          </styles.Footer>
        </styles.Container>
      </Modal>
    );
  }
}

DeleteMenuModal.propTypes = {
  container: PropTypes.object,
};

export default compose(
  withMenu,
  withMenuModals
)(DeleteMenuModal);



// WEBPACK FOOTER //
// ./src/components/DeleteMenuModal/index.js